import { BiBorderRadius } from "react-icons/bi";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "licRefNo",
            label: "Lic Ref.No",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getLic",
          },
          {
            name: "licNo",
            label: "Lic No",
            component: "text-field",
          },
        ],
        row2: [
          {
            name: "licDate",
            label: "Lic Date",
            component: "dateselector",
            width: "50%",
          },
          {
            name: "licRegnNo",
            label: "Regn.No",
            component: "text-field",
            width: "50%",
          },
        ],
        row3: [
          {
            name: "licRegnDate",
            label: "Date",
            component: "dateselector",
            width: "50%",
          },
          {
            name: "licItemsSno",
            label: "Item SNo in Lic.",
            component: "text-field",
            width: "50%",
          },
        ],
        row4: [
          {
            name: "liccifValue",
            label: "Debit Value(CIF)",
            component: "text-field",
            dataType: "int",
          },
          {
            name: "licQuantity",
            label: "Quantity",
            component: "text-field",
            dataType: "int",
          },
        ],
        row5: [
          {
            name: "licUnit",
            label: "Unit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
          {
            name: "licValueDebited",
            label: "Debit Value(Duty)",
            component: "text-field",
            dataType: "int",
          },
        ],
        row6: [
          {
            name: "licRegPort",
            label: "Reg.Port",
            component: "text-field",
            width: "49%",
            type: "autocomplete",
            endpoint: "getPorts",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
          },
        ],
      },
    },
  ],
};
